(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-singles/assets/javascripts/route-play-singles.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-singles/assets/javascripts/route-play-singles.js');
"use strict";


const {
  CouponIdProvider
} = svs.components.tipsen.couponId;
const {
  COUPON_SINGLEROWS
} = svs.components.tipsen.engine.constants.couponTypes;
const {
  Coupon
} = svs.components.tipsen.coupon;
const {
  CouponAdditions
} = svs.components.tipsen.couponAdditions;
const {
  DetailViewRoutePlayHandler
} = svs.components.tipsen.detailViewRoutePlayHandler;
const {
  CenterToScreen
} = svs.components.tipsen.centerToScreen;
const {
  SingleCouponChoice
} = svs.components.tipsen.routePlaySingles;
const {
  BetslipRegistry
} = svs.components.tipsen.betslipRegistry;
const {
  RenderProvider
} = svs.component.tipsen.renderContext;
const {
  pageTypes
} = svs.component.tipsen.renderContext.constants;
const RoutePlaySingles = () => React.createElement(CouponIdProvider, {
  type: COUPON_SINGLEROWS
}, React.createElement(CenterToScreen, null, React.createElement(RenderProvider, {
  pageType: pageTypes.DEFAULT
}, React.createElement(SingleCouponChoice, null), React.createElement(Coupon, null), React.createElement(CouponAdditions, null)), React.createElement(DetailViewRoutePlayHandler, {
  hasSideNav: false
})), React.createElement(BetslipRegistry, null));
setGlobal('svs.components.tipsen.routePlaySingles.RoutePlaySingles', RoutePlaySingles);

 })(window);